import { injectIntl } from 'react-intl';
import AdjustPointsForm from './AdjustPointsForm';

export default injectIntl(AdjustPointsForm);
